export const communicationDetailsPageInitValue = {
  data: {
    societyName: '',
    totalCommunications: 0,
    totalUnreadCommunications: 0,
    communication: null,
    recipients: [],
    attachedDocuments: [],
    isCertificationView: false,
    isAdmin: false,
    isReadOnly: false,
    isLoading: false,
  },
  actions: {
    handleNewCommunication: () => {},
    handleToggleInboxSection: () => {},
    handleToggleSettingsSection: () => {},
    handleOpenCertification: () => {},
    handleToggleFavorite: () => {},
  },
};
